import { default as DOMPurify, type DOMPurify as DOMPurifyType } from 'dompurify';

export const configure = (domPurifyInstance: DOMPurifyType): void => {
  if (typeof domPurifyInstance.addHook !== 'function') {
    return;
  }

  domPurifyInstance.addHook('afterSanitizeAttributes', (node: Element) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
};

export const createBrowserDOMPurify = (): DOMPurifyType => {
  const domPurifyInstance = DOMPurify;
  configure(domPurifyInstance);
  return domPurifyInstance;
};

export const BrowserDOMPurify = createBrowserDOMPurify();
